export const isMobileDevice = (): boolean => {
  if (typeof window === "undefined") return false;

  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera;

  const mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

  const isMobileWidth = window.innerWidth <= 768;

  return mobileRegex.test(userAgent) || isMobileWidth;
};
